<template>
  <div class="pdf-viewer">
    <div v-if="pdf" class="pdf-viewer__document">
      <canvas
        v-for="pageNumber in pdf.numPages"
        :key="pageNumber"
        :ref="CANVAS_NAME + pageNumber"
        class="pdf-viewer__canvas"
      />
    </div>
    <v-progress-circular
      v-else
      class="pdf-viewer__loader"
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsWorker from 'pdfjs-dist/es5/build/pdf.worker.entry';

const CANVAS_NAME = 'canvas';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
  name: 'PDFViewer',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    CANVAS_NAME,
    pdf: null,
  }),
  async mounted() {
    const loadingTask = pdfjsLib.getDocument(this.url);

    this.pdf = await loadingTask.promise;
  },
  async updated() {
    for (let i = 1; i <= this.pdf.numPages; i++) {
      await this.renderPage(i);
    }
  },
  methods: {
    async renderPage(pageNumber) {
      const [canvas] = this.$refs[CANVAS_NAME + pageNumber];
      const page = await this.pdf.getPage(pageNumber);
      const scale = canvas.clientWidth / page.getViewport({ scale: 1 }).width;
      const viewport = page.getViewport({ scale });
      const canvasContext = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext,
        viewport,
      };

      page.render(renderContext);
    },
  },
};
</script>

<style scoped lang="scss">
.pdf-viewer {
  position: relative;
  padding-bottom: 100%;
}

.pdf-viewer__document {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 8px;
  background: $color-light-gray;
  border: 1px solid #000000;
  overflow-y: auto;
}

.pdf-viewer__canvas {
  display: block;
  width: 100%;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.pdf-viewer__loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
